import { Injectable } from '@angular/core'
import { Haptics, ImpactStyle } from '@capacitor/haptics'
import { Capacitor } from '@capacitor/core'
import { from } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class HapticService {
  /**
   * Slight click feedback
   */
  buttonClick(): void {
    if (!Capacitor.isNativePlatform() && typeof navigator.vibrate !== 'function') {
      return
    }

    from(Haptics.impact({ style: ImpactStyle.Medium })).subscribe()
  }

  /**
   * Slight scroll feedback
   */
  scrolledItem(): void {
    from(Haptics.impact({ style: ImpactStyle.Light })).subscribe()
  }

  /**
   * Light tick when a swipe crosses a threshold, for example when a full swipe arms.
   */
  swipeThreshold(): void {
    from(Haptics.impact({ style: ImpactStyle.Light })).subscribe()
  }

  /**
   * In app notification
   */
  notification(): void {
    from(Haptics.impact({ style: ImpactStyle.Medium })).subscribe()
  }
}
